<h1 mat-dialog-title>Update bank info?</h1>
<mat-dialog-content>
  You are updating {{data.type | lowercase}} bank to {{data.bankName}} account ending in {{data.accountNumber}}.
</mat-dialog-content>
<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" [mat-dialog-close]="true">Update</button>
</div>